import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import qs from 'qs';
import jwt_decode from 'jwt-decode';
import { appConst } from '../AppConst';

export const BASE_URL_API = appConst.URL_BASE.replace(/\/$/, '');
type jwt_decodeResult = {
    exp: number;
};

let refreshTokenRequest: Promise<any> | null = null;

const checkIsTokenExpired = (): boolean => {
    try {
        const accessToken = localStorage.getItem('access_token');
        if (!accessToken) return true;

        const data: jwt_decodeResult = jwt_decode(accessToken);
        return data.exp < Math.floor(Date.now() / 1000);
    } catch (error) {
        return true;
    }
};

const refreshToken = async () => {
    try {
        const res = await axios.post(`${BASE_URL_API}/api/account/token/refresh`, {
            access_token: localStorage.getItem('access_token'),
            refresh_token: localStorage.getItem('refresh_token')
        });

        if (res.data?.is_success) {
            const { access_token, refresh_token } = res.data.data;
            localStorage.setItem('access_token', access_token);
            localStorage.setItem('refresh_token', refresh_token);
            return access_token;
        } else {
            throw new Error('Refresh token failed');
        }
    } catch (error) {
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        window.location.href = '/login';
        return null;
    }
};

const httpClient = axios.create({
    baseURL: BASE_URL_API,
    timeout: 300000,
    paramsSerializer: (params) => qs.stringify(params, { encode: false })
});

httpClient.interceptors.request.use(
    async (config) => {
        // Ensure headers is always defined
        if (!config.headers) {
            config.headers = {} as import('axios').AxiosRequestHeaders;
        }

        const token = localStorage.getItem('access_token');

        if (token && checkIsTokenExpired()) {
            refreshTokenRequest = refreshTokenRequest || refreshToken();
            const newToken = await refreshTokenRequest;
            refreshTokenRequest = null;

            if (newToken) {
                config.headers['Authorization'] = `Bearer ${newToken}`;
            }
        } else if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }

        config.headers['language'] = localStorage.getItem('language') || 'vi';
        return config;
    },
    (error) => Promise.reject(error)
);

httpClient.interceptors.response.use(
    (response: AxiosResponse) => response,
    (error) => Promise.reject(error)
);

export default httpClient;
